import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  surveyCard: {
    maxHeight: 210,
    padding: theme.spacing(2.5),
    width: 270,
    position: "relative",
    color: theme.palette.text.primary,
  },
  closeIcon: {
    cursor: "pointer",
    fontSize: "20px",
    right: theme.spacing(1),
    top: theme.spacing(1),
    position: "absolute",
    color: theme.palette.icon.primary,
  },
  closeButton: {
    marginTop: theme.spacing(1.5),
    width: "100%",
  },
}));
